import { UrlFetcher } from '@flowus/common/hooks/url-fetcher';
import { request } from 'src/common/request';

export const urlFetcher = new UrlFetcher({
  request,
});
